import styled from 'styled-components'

const SubHeading = styled.div`
  display: block;
  padding-top: ${({ theme }) => theme.spacing(1)}px;
`

export default SubHeading
